// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AnswerMessageApiChatMessageSessionIdPostData, AnswerMessageApiChatMessageSessionIdPostErrors, AnswerMessageApiChatMessageSessionIdPostResponses, BotNameEndpointApiChatBotNameGetData, BotNameEndpointApiChatBotNameGetResponses, CheckDoclinkExistsApiDoclinksFilenameHeadData, CheckDoclinkExistsApiDoclinksFilenameHeadErrors, CheckDoclinkExistsApiDoclinksFilenameHeadResponses, CreateLexiconConceptApiLexiconConceptsPostData, CreateLexiconConceptApiLexiconConceptsPostErrors, CreateLexiconConceptApiLexiconConceptsPostResponses, CreateSchemaApiIngestionSchemasPostData, CreateSchemaApiIngestionSchemasPostErrors, CreateSchemaApiIngestionSchemasPostResponses, DeleteConversationApiConversationsSessionIdDeleteData, DeleteConversationApiConversationsSessionIdDeleteErrors, DeleteConversationApiConversationsSessionIdDeleteResponses, DeleteCorpusDocumentsApiAdminVectorstoreDeletionsPostData, DeleteCorpusDocumentsApiAdminVectorstoreDeletionsPostErrors, DeleteCorpusDocumentsApiAdminVectorstoreDeletionsPostResponses, DeleteLexiconConceptApiLexiconConceptsUniqueDeleteData, DeleteLexiconConceptApiLexiconConceptsUniqueDeleteErrors, DeleteLexiconConceptApiLexiconConceptsUniqueDeleteResponses, DeleteSchemaApiIngestionSchemasSchemaIdDeleteData, DeleteSchemaApiIngestionSchemasSchemaIdDeleteErrors, DeleteSchemaApiIngestionSchemasSchemaIdDeleteResponses, DownloadBlobFileApiDocumentsDownloadBlobPathGetData, DownloadBlobFileApiDocumentsDownloadBlobPathGetErrors, DownloadBlobFileApiDocumentsDownloadBlobPathGetResponses, DownloadDoclinkFileApiDoclinksFilenameDownloadGetData, DownloadDoclinkFileApiDoclinksFilenameDownloadGetErrors, DownloadDoclinkFileApiDoclinksFilenameDownloadGetResponses, FeedbackApiChatFeedbackSessionIdMessageIdPutData, FeedbackApiChatFeedbackSessionIdMessageIdPutErrors, FeedbackApiChatFeedbackSessionIdMessageIdPutResponses, GetChunkImageApiImagesChunkUniqueGetData, GetChunkImageApiImagesChunkUniqueGetErrors, GetChunkImageApiImagesChunkUniqueGetResponses, GetConnectorsApiIngestionConnectorsGetData, GetConnectorsApiIngestionConnectorsGetResponses, GetConversationApiConversationsSessionIdGetData, GetConversationApiConversationsSessionIdGetErrors, GetConversationApiConversationsSessionIdGetResponses, GetConversationHistoryApiConversationsGetData, GetConversationHistoryApiConversationsGetErrors, GetConversationHistoryApiConversationsGetResponses, GetCorpusAccessApiAdminVectorstoreAccessGetData, GetCorpusAccessApiAdminVectorstoreAccessGetResponses, GetCorpusDocumentApiAdminVectorstoreDocumentsDetailGetData, GetCorpusDocumentApiAdminVectorstoreDocumentsDetailGetErrors, GetCorpusDocumentApiAdminVectorstoreDocumentsDetailGetResponses, GetCorpusFieldValuesApiAdminVectorstoreValuesGetData, GetCorpusFieldValuesApiAdminVectorstoreValuesGetErrors, GetCorpusFieldValuesApiAdminVectorstoreValuesGetResponses, GetCorpusOverviewApiAdminVectorstoreOverviewGetData, GetCorpusOverviewApiAdminVectorstoreOverviewGetResponses, GetDoclinkFileApiDoclinksFilenameGetData, GetDoclinkFileApiDoclinksFilenameGetErrors, GetDoclinkFileApiDoclinksFilenameGetResponses, GetGreetingsApiChatGetGreetingsSessionIdPostData, GetGreetingsApiChatGetGreetingsSessionIdPostErrors, GetGreetingsApiChatGetGreetingsSessionIdPostResponses, GetItemImageApiItemImagesImageIdGetData, GetItemImageApiItemImagesImageIdGetErrors, GetItemImageApiItemImagesImageIdGetResponses, GetLexiconConceptsBySubjectApiLexiconSubjectSubjectGetData, GetLexiconConceptsBySubjectApiLexiconSubjectSubjectGetErrors, GetLexiconConceptsBySubjectApiLexiconSubjectSubjectGetResponses, GetLexiconSubjectsApiLexiconSubjectsGetData, GetLexiconSubjectsApiLexiconSubjectsGetResponses, GetProviderApiIngestionProviderGetData, GetProviderApiIngestionProviderGetResponses, GetSchemaApiIngestionSchemasSchemaIdGetData, GetSchemaApiIngestionSchemasSchemaIdGetErrors, GetSchemaApiIngestionSchemasSchemaIdGetResponses, GetTaskStatusApiIngestionTriggerTaskIdGetData, GetTaskStatusApiIngestionTriggerTaskIdGetErrors, GetTaskStatusApiIngestionTriggerTaskIdGetResponses, GetUploadStatusApiDocumentsUploadJobIdGetData, GetUploadStatusApiDocumentsUploadJobIdGetErrors, GetUploadStatusApiDocumentsUploadJobIdGetResponses, InitializeConversationApiChatInitializeConversationGetData, InitializeConversationApiChatInitializeConversationGetResponses, ListAllSchemasApiIngestionSchemasAllGetData, ListAllSchemasApiIngestionSchemasAllGetResponses, ListGoogleDriveFoldersApiIngestionGoogleDriveFoldersGetData, ListGoogleDriveFoldersApiIngestionGoogleDriveFoldersGetResponses, ListIngestionJobsApiDocumentsUploadGetData, ListIngestionJobsApiDocumentsUploadGetErrors, ListIngestionJobsApiDocumentsUploadGetResponses, ListSchemasApiIngestionSchemasGetData, ListSchemasApiIngestionSchemasGetErrors, ListSchemasApiIngestionSchemasGetResponses, PatchSchemaApiIngestionSchemasSchemaIdPatchData, PatchSchemaApiIngestionSchemasSchemaIdPatchErrors, PatchSchemaApiIngestionSchemasSchemaIdPatchResponses, PreviewCorpusDeletionApiAdminVectorstoreDeletionsPreviewPostData, PreviewCorpusDeletionApiAdminVectorstoreDeletionsPreviewPostErrors, PreviewCorpusDeletionApiAdminVectorstoreDeletionsPreviewPostResponses, QueryCorpusDocumentsApiAdminVectorstoreDocumentsQueryPostData, QueryCorpusDocumentsApiAdminVectorstoreDocumentsQueryPostErrors, QueryCorpusDocumentsApiAdminVectorstoreDocumentsQueryPostResponses, RedirectToConformitSourceApiDocumentsConformitSourceProcedureIdGetData, RedirectToConformitSourceApiDocumentsConformitSourceProcedureIdGetErrors, RedirectToConformitSourceApiDocumentsConformitSourceProcedureIdGetResponses, RestoreConversationApiConversationsSessionIdRestorePostData, RestoreConversationApiConversationsSessionIdRestorePostErrors, RestoreConversationApiConversationsSessionIdRestorePostResponses, SignViewerUrlApiDocumentsSignUrlPostData, SignViewerUrlApiDocumentsSignUrlPostErrors, SignViewerUrlApiDocumentsSignUrlPostResponses, StartIngestionJobApiDocumentsUploadPostData, StartIngestionJobApiDocumentsUploadPostErrors, StartIngestionJobApiDocumentsUploadPostResponses, TriggerIngestionApiIngestionTriggerPostData, TriggerIngestionApiIngestionTriggerPostErrors, TriggerIngestionApiIngestionTriggerPostResponses, UpdateConversationApiConversationsSessionIdPutData, UpdateConversationApiConversationsSessionIdPutErrors, UpdateConversationApiConversationsSessionIdPutResponses, UpdateLexiconConceptApiLexiconConceptsUniquePutData, UpdateLexiconConceptApiLexiconConceptsUniquePutErrors, UpdateLexiconConceptApiLexiconConceptsUniquePutResponses, WebappVersionEndpointApiVersionGetData, WebappVersionEndpointApiVersionGetResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Bot Name Endpoint
 *
 * Get the bot name.
 *
 * Returns:
 * str: The bot name.
 */
export const botNameEndpointApiChatBotNameGet = <ThrowOnError extends boolean = false>(options?: Options<BotNameEndpointApiChatBotNameGetData, ThrowOnError>) => (options?.client ?? client).get<BotNameEndpointApiChatBotNameGetResponses, unknown, ThrowOnError>({ url: '/api/chat/bot-name', ...options });

/**
 * Initialize Conversation
 *
 * Get a session ID.
 */
export const initializeConversationApiChatInitializeConversationGet = <ThrowOnError extends boolean = false>(options?: Options<InitializeConversationApiChatInitializeConversationGetData, ThrowOnError>) => (options?.client ?? client).get<InitializeConversationApiChatInitializeConversationGetResponses, unknown, ThrowOnError>({ url: '/api/chat/initialize-conversation', ...options });

/**
 * Get Greetings
 *
 * Initialize a conversation to be greeted by the bot.
 *
 * POST request that triggers a SSE stream of events (https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events/Using_server-sent_events).
 *
 * Args:
 * session_id: The session ID.
 * user_id: The user ID.
 * event_sender: The event sender.
 * chat_orchestrator: The chat orchestrator.
 *
 * Returns:
 * EventSourceResponse: The event source response that streams events to the client.
 */
export const getGreetingsApiChatGetGreetingsSessionIdPost = <ThrowOnError extends boolean = false>(options: Options<GetGreetingsApiChatGetGreetingsSessionIdPostData, ThrowOnError>) => (options.client ?? client).post<GetGreetingsApiChatGetGreetingsSessionIdPostResponses, GetGreetingsApiChatGetGreetingsSessionIdPostErrors, ThrowOnError>({ url: '/api/chat/get-greetings/{session_id}', ...options });

/**
 * Answer Message
 *
 * Send a message to the bot.
 *
 * POST request that triggers a SSE stream of events (https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events/Using_server-sent_events).
 *
 * Args:
 * session_id: The session ID.
 * user_id: The user ID.
 * chat_orchestrator: The chat orchestrator.
 * event_sender: The SSE event sender.
 * request_body: The request body.
 *
 * Returns:
 * EventSourceResponse: The event source response that streams events to the client.
 */
export const answerMessageApiChatMessageSessionIdPost = <ThrowOnError extends boolean = false>(options: Options<AnswerMessageApiChatMessageSessionIdPostData, ThrowOnError>) => (options.client ?? client).post<AnswerMessageApiChatMessageSessionIdPostResponses, AnswerMessageApiChatMessageSessionIdPostErrors, ThrowOnError>({
    url: '/api/chat/message/{session_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Feedback
 *
 * Save feedback for a message.
 *
 * Args:
 * artifact_archive_service: The artifact archive service.
 * request_body: The request body containing the feedback.
 * session_id: The session ID.
 * message_id: The message ID.
 * user_id: The user ID.
 *
 * Returns:
 * Response: The response indicating the status of the operation.
 */
export const feedbackApiChatFeedbackSessionIdMessageIdPut = <ThrowOnError extends boolean = false>(options: Options<FeedbackApiChatFeedbackSessionIdMessageIdPutData, ThrowOnError>) => (options.client ?? client).put<FeedbackApiChatFeedbackSessionIdMessageIdPutResponses, FeedbackApiChatFeedbackSessionIdMessageIdPutErrors, ThrowOnError>({
    url: '/api/chat/feedback/{session_id}/{message_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redirect To Conformit Source
 *
 * Redirect to the ConformIT PDF for an ingested lockout procedure.
 *
 * For the procedure's page in ConformIT, use the document's `source_url` directly;
 * this endpoint serves the generated PDF instead. Its download link expires after 6
 * hours and is a fresh S3 object each time, so it is minted per click rather than
 * stored.
 *
 * Classified as corpus-wide read (see module docstring): any authenticated user may
 * follow it, provided the procedure was actually ingested —
 * `_assert_procedure_is_corpus_document` is what enforces that, not `user_id` itself.
 *
 * Args:
 * procedure_id: ConformIT procedure id, as stored in `source_url`.
 * user_id: Authenticated Clerk user_id (from middleware).
 *
 * Returns:
 * A temporary redirect to a freshly minted, short-lived download URL.
 *
 * Raises:
 * HTTPException: 404 if the procedure was never ingested or ConformIT returns no
 * link, 503 if ConformIT is unreachable or not configured.
 */
export const redirectToConformitSourceApiDocumentsConformitSourceProcedureIdGet = <ThrowOnError extends boolean = false>(options: Options<RedirectToConformitSourceApiDocumentsConformitSourceProcedureIdGetData, ThrowOnError>) => (options.client ?? client).get<RedirectToConformitSourceApiDocumentsConformitSourceProcedureIdGetResponses, RedirectToConformitSourceApiDocumentsConformitSourceProcedureIdGetErrors, ThrowOnError>({ url: '/api/documents/conformit-source/{procedure_id}', ...options });

/**
 * Get Conversation History
 *
 * Get the conversation history of the logged in user. Liked conversations appear first, then sorted by most recent message. Returns only conversations with at least one user message.
 *
 * Args:
 * artifact_archive_service: The artifact archive service.
 * user_id: The user ID.
 * limit: The limit.
 * offset: The offset.
 * filter_text: Optional substring to filter conversations by name.
 * deleted: Whether to return deleted conversations.
 *
 * Returns:
 * list[ConversationSummary]: List of conversation summaries.
 * total_count: The total number of conversations.
 * offset: The offset.
 * limit: The limit.
 */
export const getConversationHistoryApiConversationsGet = <ThrowOnError extends boolean = false>(options?: Options<GetConversationHistoryApiConversationsGetData, ThrowOnError>) => (options?.client ?? client).get<GetConversationHistoryApiConversationsGetResponses, GetConversationHistoryApiConversationsGetErrors, ThrowOnError>({ url: '/api/conversations', ...options });

/**
 * Delete Conversation
 *
 * Delete a conversation by session ID. Removes all artifacts associated with the session.
 *
 * Args:
 * session_id: The session ID.
 * user_id: The user ID.
 * artifact_archive_service: The artifact archive service.
 *
 * Returns:
 * 204 No Content on success.
 */
export const deleteConversationApiConversationsSessionIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteConversationApiConversationsSessionIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteConversationApiConversationsSessionIdDeleteResponses, DeleteConversationApiConversationsSessionIdDeleteErrors, ThrowOnError>({ url: '/api/conversations/{session_id}', ...options });

/**
 * Get Conversation
 *
 * Get a conversation by session ID. Returns messages and used_sources to reconstruct the conversation when the user clicks on a conversation in the conversation history.
 *
 * Args:
 * session_id: The session ID.
 * user_id: The user ID.
 * artifact_archive_service: The artifact archive service.
 *
 * Returns:
 * ConversationRequestResponse: The conversation request response.
 */
export const getConversationApiConversationsSessionIdGet = <ThrowOnError extends boolean = false>(options: Options<GetConversationApiConversationsSessionIdGetData, ThrowOnError>) => (options.client ?? client).get<GetConversationApiConversationsSessionIdGetResponses, GetConversationApiConversationsSessionIdGetErrors, ThrowOnError>({ url: '/api/conversations/{session_id}', ...options });

/**
 * Update Conversation
 *
 * Update a conversation by session ID. Accepts an optional name and/or liked flag.
 *
 * Args:
 * session_id: The session ID.
 * body: The request body containing the fields to update.
 * user_id: The user ID.
 * artifact_archive_service: The artifact archive service.
 *
 * Returns:
 * 204 No Content on success.
 */
export const updateConversationApiConversationsSessionIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateConversationApiConversationsSessionIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateConversationApiConversationsSessionIdPutResponses, UpdateConversationApiConversationsSessionIdPutErrors, ThrowOnError>({
    url: '/api/conversations/{session_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore Conversation
 *
 * Restore a soft-deleted conversation by session ID.
 *
 * Args:
 * session_id: The session ID.
 * user_id: The user ID.
 * artifact_archive_service: The artifact archive service.
 *
 * Returns:
 * 204 No Content on success.
 */
export const restoreConversationApiConversationsSessionIdRestorePost = <ThrowOnError extends boolean = false>(options: Options<RestoreConversationApiConversationsSessionIdRestorePostData, ThrowOnError>) => (options.client ?? client).post<RestoreConversationApiConversationsSessionIdRestorePostResponses, RestoreConversationApiConversationsSessionIdRestorePostErrors, ThrowOnError>({ url: '/api/conversations/{session_id}/restore', ...options });

/**
 * Get Doclink File
 *
 * Fetch and serve a doclink file.
 *
 * Downloads the file on-demand with fallback sources:
 * 1. Maximo OSLC API - primary source (always has the file if indexed)
 * 2. SMB share (Windows file server) - fallback
 *
 * Requires authentication (module docstring: upstream-authorized, with a known gap — this
 * does not, and currently cannot, check that the caller specifically is entitled to this
 * doclink).
 *
 * Args:
 * filename: Name of file (e.g., "sfppn1603.pdf").
 * user_id: Authenticated Clerk user_id (from middleware, bearer or signed URL).
 *
 * Returns:
 * File content with appropriate MIME type for inline display.
 *
 * Raises:
 * 404: File not found on any source.
 * 503: Connection error to all sources.
 */
export const getDoclinkFileApiDoclinksFilenameGet = <ThrowOnError extends boolean = false>(options: Options<GetDoclinkFileApiDoclinksFilenameGetData, ThrowOnError>) => (options.client ?? client).get<GetDoclinkFileApiDoclinksFilenameGetResponses, GetDoclinkFileApiDoclinksFilenameGetErrors, ThrowOnError>({ url: '/api/doclinks/{filename}', ...options });

/**
 * Check Doclink Exists
 *
 * Check if a doclink file exists on the SMB share.
 *
 * Useful for validating file availability without downloading.
 *
 * Requires authentication (see module docstring for the upstream-authorized classification
 * and its known gap).
 *
 * Args:
 * filename: Name of file to check.
 * user_id: Authenticated Clerk user_id (from middleware, bearer or signed URL).
 *
 * Returns:
 * 200 with Content-Length/Content-Type if file exists, 404 if not found.
 */
export const checkDoclinkExistsApiDoclinksFilenameHead = <ThrowOnError extends boolean = false>(options: Options<CheckDoclinkExistsApiDoclinksFilenameHeadData, ThrowOnError>) => (options.client ?? client).head<CheckDoclinkExistsApiDoclinksFilenameHeadResponses, CheckDoclinkExistsApiDoclinksFilenameHeadErrors, ThrowOnError>({ url: '/api/doclinks/{filename}', ...options });

/**
 * Download Doclink File
 *
 * Download a doclink file as attachment.
 *
 * Same as get_doclink_file but with Content-Disposition: attachment
 * to force browser download dialog.
 *
 * Requires authentication (see module docstring for the upstream-authorized classification
 * and its known gap).
 *
 * Args:
 * filename: Name of file.
 * user_id: Authenticated Clerk user_id (from middleware, bearer or signed URL).
 *
 * Returns:
 * File content as downloadable attachment.
 */
export const downloadDoclinkFileApiDoclinksFilenameDownloadGet = <ThrowOnError extends boolean = false>(options: Options<DownloadDoclinkFileApiDoclinksFilenameDownloadGetData, ThrowOnError>) => (options.client ?? client).get<DownloadDoclinkFileApiDoclinksFilenameDownloadGetResponses, DownloadDoclinkFileApiDoclinksFilenameDownloadGetErrors, ThrowOnError>({ url: '/api/doclinks/{filename}/download', ...options });

/**
 * Download Blob File
 *
 * Download a file from Azure Blob Storage by its blob path.
 *
 * This endpoint serves files directly from blob storage using the blob path
 * (prefix/filename). Used by the frontend to access document sources.
 *
 * Classified as corpus-wide read (see module docstring): any authenticated user may
 * download it, provided it actually corresponds to an ingested corpus document —
 * `_assert_blob_is_corpus_document` is what enforces that, not `user_id` itself.
 *
 * Args:
 * blob_path: Blob path within the container (e.g., prefix/file.pdf).
 * user_id: Authenticated Clerk user_id (from middleware, bearer or signed URL).
 *
 * Returns:
 * The requested file with the correct content-type.
 *
 * Raises:
 * HTTPException: If the file is not found or the path is invalid.
 */
export const downloadBlobFileApiDocumentsDownloadBlobPathGet = <ThrowOnError extends boolean = false>(options: Options<DownloadBlobFileApiDocumentsDownloadBlobPathGetData, ThrowOnError>) => (options.client ?? client).get<DownloadBlobFileApiDocumentsDownloadBlobPathGetResponses, DownloadBlobFileApiDocumentsDownloadBlobPathGetErrors, ThrowOnError>({ url: '/api/documents/download/{blob_path}', ...options });

/**
 * Sign Viewer Url
 *
 * Mint a short-lived HMAC-signed URL for the PDF viewer iframe.
 *
 * The browser cannot set an Authorization header on iframe src, so the
 * download endpoint accepts a signed URL with query params expires/uid/sig.
 * The signed URL is scoped to one blob_path and one user_id, and expires
 * after settings.viewer_url_ttl_seconds (default 300 s / 5 min).
 *
 * Classified as corpus-wide read (see module docstring): before minting, verify the blob
 * resolves to a real ingested document chunk rather than trusting any shape-valid path.
 *
 * Note: `mint_signed_url` also supports a `doclinks/`-prefixed `blob_path` for the Maximo
 * doclinks proxy, but no current caller (web or mobile) exercises that branch through this
 * endpoint — the corpus-membership check below only covers blob-storage documents. If a
 * doclinks-signing caller is added later, it will need its own upstream-authorized check
 * (see `doclinks.py`), not this one.
 *
 * Args:
 * body: Request body with the blob path to sign.
 * user_id: Authenticated Clerk user_id (from middleware).
 *
 * Returns:
 * SignUrlResponse with the relative signed URL and absolute expiration.
 *
 * Raises:
 * HTTPException: 400 if the path shape is invalid, 404 if it isn't a real corpus document.
 */
export const signViewerUrlApiDocumentsSignUrlPost = <ThrowOnError extends boolean = false>(options: Options<SignViewerUrlApiDocumentsSignUrlPostData, ThrowOnError>) => (options.client ?? client).post<SignViewerUrlApiDocumentsSignUrlPostResponses, SignViewerUrlApiDocumentsSignUrlPostErrors, ThrowOnError>({
    url: '/api/documents/sign-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Ingestion Jobs
 *
 * List ingestion jobs with pagination and optional phase filter.
 *
 * Any authenticated caller may read all jobs (see module docstring for authorization model).
 *
 * Args:
 * user_id: Authenticated Clerk user_id (from middleware); required to reject anonymous.
 * limit: Maximum number of jobs to return.
 * offset: Number of jobs to skip for pagination.
 * phase: Optional filter by job phase.
 *
 * Returns:
 * List of job summaries and total count.
 */
export const listIngestionJobsApiDocumentsUploadGet = <ThrowOnError extends boolean = false>(options?: Options<ListIngestionJobsApiDocumentsUploadGetData, ThrowOnError>) => (options?.client ?? client).get<ListIngestionJobsApiDocumentsUploadGetResponses, ListIngestionJobsApiDocumentsUploadGetErrors, ThrowOnError>({ url: '/api/documents/upload', ...options });

/**
 * Start Ingestion Job
 *
 * Start an asynchronous ingestion job.
 *
 * The job proceeds in phases:
 * 2. Ingest files into Qdrant for semantic search (parallel)
 * 3. (Optional) Extract and analyze images from PDFs with Claude Vision
 *
 * Returns immediately with a job ID. Use GET /upload/{job_id} to track progress.
 *
 * Supports:
 * - Single file upload
 * - Multiple file upload (select multiple in file picker)
 * - Folder upload (browser sends paths via webkitdirectory)
 *
 * Args:
 * files: List of files to upload (multipart form-data).
 * user_id: Authenticated Clerk user_id (from middleware); required so anonymous callers
 * are rejected, and recorded on the job as an audit trail (`created_by`) — read
 * access via `GET /upload/{job_id}` is not gated on it (corpus-wide classification).
 * prefix: Optional path prefix (e.g., "procedures/2024/").
 * overwrite: Whether to replace existing files in blob storage.
 * skip_ingestion: If true, only upload to blob without Qdrant ingestion.
 * with_vision: If true, extract and analyze images from PDFs using Claude Vision.
 *
 * Returns:
 * Job ID and initial status.
 */
export const startIngestionJobApiDocumentsUploadPost = <ThrowOnError extends boolean = false>(options: Options<StartIngestionJobApiDocumentsUploadPostData, ThrowOnError>) => (options.client ?? client).post<StartIngestionJobApiDocumentsUploadPostResponses, StartIngestionJobApiDocumentsUploadPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/documents/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Upload Status
 *
 * Get the status of an upload + ingestion job.
 *
 * Classified as corpus-wide / any authenticated user (see module docstring): any
 * authenticated caller may read any job's status, same as they may read all corpus content.
 * `user_id` is required only to reject anonymous access — it is not compared against
 * `IngestionJob.created_by`, which is recorded purely as an audit trail.
 *
 * Args:
 * job_id: The job ID returned by POST /upload.
 * user_id: Authenticated Clerk user_id (from middleware); required so anonymous callers
 * are rejected, not compared against job ownership.
 * include_files: Whether to include detailed per-file status.
 *
 * Returns:
 * Current phase, progress counters, and optionally file details.
 */
export const getUploadStatusApiDocumentsUploadJobIdGet = <ThrowOnError extends boolean = false>(options: Options<GetUploadStatusApiDocumentsUploadJobIdGetData, ThrowOnError>) => (options.client ?? client).get<GetUploadStatusApiDocumentsUploadJobIdGetResponses, GetUploadStatusApiDocumentsUploadJobIdGetErrors, ThrowOnError>({ url: '/api/documents/upload/{job_id}', ...options });

/**
 * Get Chunk Image
 *
 * Serve the PNG image associated with a Vision-extracted DocumentChunk.
 *
 * Fetches the image from blob storage (Azure or Azurite) using
 * the URL stored in image_blob_url.
 *
 * Classified as corpus-wide read (see `documents.py`'s module docstring): any authenticated
 * user may view it. The `chunk_unique` lookup below is already scoped to real corpus content
 * (a nonexistent id 404s), so `user_id` exists to make "authenticated caller required" an
 * explicit, testable part of this endpoint rather than an implicit side effect of
 * `ClerkMiddleware` running before every non-public route.
 *
 * Args:
 * chunk_unique: The unique identifier of the DocumentChunk.
 * user_id: Authenticated Clerk user_id (from middleware).
 *
 * Returns:
 * The PNG image as a binary response.
 */
export const getChunkImageApiImagesChunkUniqueGet = <ThrowOnError extends boolean = false>(options: Options<GetChunkImageApiImagesChunkUniqueGetData, ThrowOnError>) => (options.client ?? client).get<GetChunkImageApiImagesChunkUniqueGetResponses, GetChunkImageApiImagesChunkUniqueGetErrors, ThrowOnError>({ url: '/api/images/{chunk_unique}', ...options });

/**
 * Trigger an ingestion task
 *
 * Launch an ingestion task on the appropriate infrastructure (ECS/ACA/HTTP).
 */
export const triggerIngestionApiIngestionTriggerPost = <ThrowOnError extends boolean = false>(options: Options<TriggerIngestionApiIngestionTriggerPostData, ThrowOnError>) => (options.client ?? client).post<TriggerIngestionApiIngestionTriggerPostResponses, TriggerIngestionApiIngestionTriggerPostErrors, ThrowOnError>({
    url: '/api/ingestion/trigger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get ingestion task status
 *
 * Get the status of a running ingestion task.
 */
export const getTaskStatusApiIngestionTriggerTaskIdGet = <ThrowOnError extends boolean = false>(options: Options<GetTaskStatusApiIngestionTriggerTaskIdGetData, ThrowOnError>) => (options.client ?? client).get<GetTaskStatusApiIngestionTriggerTaskIdGetResponses, GetTaskStatusApiIngestionTriggerTaskIdGetErrors, ThrowOnError>({ url: '/api/ingestion/trigger/{task_id}', ...options });

/**
 * List configured Google Drive folders
 *
 * Returns the root folders configured in GOOGLE_DRIVE_FOLDERS, for the sync panel's folder picker. Empty when Google Drive is not configured.
 */
export const listGoogleDriveFoldersApiIngestionGoogleDriveFoldersGet = <ThrowOnError extends boolean = false>(options?: Options<ListGoogleDriveFoldersApiIngestionGoogleDriveFoldersGetData, ThrowOnError>) => (options?.client ?? client).get<ListGoogleDriveFoldersApiIngestionGoogleDriveFoldersGetResponses, unknown, ThrowOnError>({ url: '/api/ingestion/google-drive/folders', ...options });

/**
 * Get configured connectors
 *
 * Returns which connector sources have credentials configured, so the admin UI can hide the others.
 */
export const getConnectorsApiIngestionConnectorsGet = <ThrowOnError extends boolean = false>(options?: Options<GetConnectorsApiIngestionConnectorsGetData, ThrowOnError>) => (options?.client ?? client).get<GetConnectorsApiIngestionConnectorsGetResponses, unknown, ThrowOnError>({ url: '/api/ingestion/connectors', ...options });

/**
 * Get current cloud provider
 *
 * Returns the detected cloud provider for ingestion tasks.
 */
export const getProviderApiIngestionProviderGet = <ThrowOnError extends boolean = false>(options?: Options<GetProviderApiIngestionProviderGetData, ThrowOnError>) => (options?.client ?? client).get<GetProviderApiIngestionProviderGetResponses, unknown, ThrowOnError>({ url: '/api/ingestion/provider', ...options });

/**
 * Get Item Image
 *
 * Fetch and serve an item image from Maximo image library.
 *
 * Maximo images require API key authentication. This endpoint proxies
 * the request, adding the credential and caching the response.
 *
 * Requires authentication (see module docstring for the upstream-authorized classification
 * and its known gap).
 *
 * Args:
 * image_id: Maximo image ID from `_imagelibref` URL. Numeric only.
 * Example: If _imagelibref is https://maximo.../api/images/45561,
 * the image_id is "45561".
 * user_id: Authenticated Clerk user_id (from middleware).
 *
 * Returns:
 * Binary image content (typically JPEG) with caching headers.
 *
 * Raises:
 * HTTPException: 400 if image_id is not numeric, 404 if the image is
 * not found, 502/503/504 on Maximo API errors, 503 if the Maximo
 * API is not configured.
 */
export const getItemImageApiItemImagesImageIdGet = <ThrowOnError extends boolean = false>(options: Options<GetItemImageApiItemImagesImageIdGetData, ThrowOnError>) => (options.client ?? client).get<GetItemImageApiItemImagesImageIdGetResponses, GetItemImageApiItemImagesImageIdGetErrors, ThrowOnError>({ url: '/api/item-images/{image_id}', ...options });

/**
 * Get Lexicon Subjects
 *
 * Return all distinct subjects as bilingual (en/fr) pairs.
 *
 * Uses Qdrant facet API for efficient retrieval — returns all subjects
 * in a single response with no pagination.
 *
 * Args:
 * user_id: Authenticated user ID (injected by Clerk middleware).
 * search_service: Search service (injected from container).
 *
 * Returns:
 * All distinct subjects sorted alphabetically.
 */
export const getLexiconSubjectsApiLexiconSubjectsGet = <ThrowOnError extends boolean = false>(options?: Options<GetLexiconSubjectsApiLexiconSubjectsGetData, ThrowOnError>) => (options?.client ?? client).get<GetLexiconSubjectsApiLexiconSubjectsGetResponses, unknown, ThrowOnError>({ url: '/api/lexicon/subjects', ...options });

/**
 * Get Lexicon Concepts By Subject
 *
 * Return one page of lexicon concepts belonging to the given subject.
 *
 * Uses cursor-based pagination: each call returns at most ``limit``
 * concepts plus a ``next_cursor`` to fetch the following page.
 *
 * Args:
 * subject: The subject value to filter on (e.g. ``"Gemmology"`` or
 * ``"Gemmologie"``).
 * lang: Language of the provided subject — ``"en"`` matches
 * ``subject_en``, ``"fr"`` matches ``subject_fr``. Defaults to
 * ``"en"``.
 * limit: Maximum number of concepts per page (1..500, default 100).
 * cursor: Opaque cursor from a previous call; omit to start from the
 * beginning.
 * user_id: Authenticated user ID (injected by Clerk middleware).
 * search_service: Search service (injected from container).
 *
 * Returns:
 * One page of lexicon concepts plus a ``next_cursor`` (``null`` when
 * the subject's concepts are fully consumed).
 */
export const getLexiconConceptsBySubjectApiLexiconSubjectSubjectGet = <ThrowOnError extends boolean = false>(options: Options<GetLexiconConceptsBySubjectApiLexiconSubjectSubjectGetData, ThrowOnError>) => (options.client ?? client).get<GetLexiconConceptsBySubjectApiLexiconSubjectSubjectGetResponses, GetLexiconConceptsBySubjectApiLexiconSubjectSubjectGetErrors, ThrowOnError>({ url: '/api/lexicon/subject/{subject}', ...options });

/**
 * Create Lexicon Concept
 *
 * Create a new lexicon concept and insert it into the vectorstore.
 *
 * Contributing terminology is a normal end-user action: the people who hold
 * the domain vocabulary are the ones who encounter a missing term, and the
 * conversational agent invites them to add it when a term blocks it. So this
 * endpoint requires authentication only — no privileged role. Creation only
 * ever adds; editing and deleting existing concepts overwrite or destroy
 * shared state that is not recoverable from the UI, so both stay privileged.
 *
 * Args:
 * body: The concept data to insert.
 * vectorstore: Lexicon concept vectorstore (injected from container).
 *
 * Returns:
 * The created lexicon concept, including its generated unique identifier.
 */
export const createLexiconConceptApiLexiconConceptsPost = <ThrowOnError extends boolean = false>(options: Options<CreateLexiconConceptApiLexiconConceptsPostData, ThrowOnError>) => (options.client ?? client).post<CreateLexiconConceptApiLexiconConceptsPostResponses, CreateLexiconConceptApiLexiconConceptsPostErrors, ThrowOnError>({
    url: '/api/lexicon/concepts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Lexicon Concept
 *
 * Delete a lexicon concept identified by its unique ID.
 *
 * Gated behind `require_privileged_role`, as updating is: only creation is
 * open to any authenticated user. Removing a concept destroys shared state
 * that feeds retrieval for everyone and cannot be undone from the UI.
 *
 * Args:
 * unique: The unique identifier of the concept to delete.
 * vectorstore: Lexicon concept vectorstore (injected from container).
 */
export const deleteLexiconConceptApiLexiconConceptsUniqueDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteLexiconConceptApiLexiconConceptsUniqueDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteLexiconConceptApiLexiconConceptsUniqueDeleteResponses, DeleteLexiconConceptApiLexiconConceptsUniqueDeleteErrors, ThrowOnError>({ url: '/api/lexicon/concepts/{unique}', ...options });

/**
 * Update Lexicon Concept
 *
 * Update an existing lexicon concept identified by its unique ID.
 *
 * Privileged, unlike creation. This is a full replacement, not a patch: the
 * whole point is upserted, so an edit silently discards whatever the previous
 * definition said. Concepts feed `search_lexicon`, hence the prompt of every
 * user, and the entity carries no author or timestamp — so a wrong edit is
 * both org-wide and untraceable afterwards. That is the same "destroys shared
 * state, not recoverable from the UI" reasoning that keeps DELETE privileged.
 *
 * Adding a missing term (POST) carries none of that: it only ever adds, and
 * the contributor is the person who hit the gap.
 *
 * Args:
 * unique: The unique identifier of the concept to update.
 * body: The updated concept data.
 * vectorstore: Lexicon concept vectorstore (injected from container).
 *
 * Returns:
 * The updated lexicon concept.
 *
 * Raises:
 * HTTPException: 404 if no concept with the given unique ID exists.
 */
export const updateLexiconConceptApiLexiconConceptsUniquePut = <ThrowOnError extends boolean = false>(options: Options<UpdateLexiconConceptApiLexiconConceptsUniquePutData, ThrowOnError>) => (options.client ?? client).put<UpdateLexiconConceptApiLexiconConceptsUniquePutResponses, UpdateLexiconConceptApiLexiconConceptsUniquePutErrors, ThrowOnError>({
    url: '/api/lexicon/concepts/{unique}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Schemas
 *
 * List all schema IDs with pagination.
 */
export const listSchemasApiIngestionSchemasGet = <ThrowOnError extends boolean = false>(options?: Options<ListSchemasApiIngestionSchemasGetData, ThrowOnError>) => (options?.client ?? client).get<ListSchemasApiIngestionSchemasGetResponses, ListSchemasApiIngestionSchemasGetErrors, ThrowOnError>({ url: '/api/ingestion/schemas', ...options });

/**
 * Create Schema
 *
 * Create a new schema. Returns 409 if schema_id already exists.
 */
export const createSchemaApiIngestionSchemasPost = <ThrowOnError extends boolean = false>(options: Options<CreateSchemaApiIngestionSchemasPostData, ThrowOnError>) => (options.client ?? client).post<CreateSchemaApiIngestionSchemasPostResponses, CreateSchemaApiIngestionSchemasPostErrors, ThrowOnError>({
    url: '/api/ingestion/schemas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List All Schemas
 *
 * List all schemas with full details in a single request.
 *
 * Use this endpoint for admin UIs that need complete schema data.
 * For large schema counts, prefer the paginated list endpoint.
 */
export const listAllSchemasApiIngestionSchemasAllGet = <ThrowOnError extends boolean = false>(options?: Options<ListAllSchemasApiIngestionSchemasAllGetData, ThrowOnError>) => (options?.client ?? client).get<ListAllSchemasApiIngestionSchemasAllGetResponses, unknown, ThrowOnError>({ url: '/api/ingestion/schemas/all', ...options });

/**
 * Delete Schema
 *
 * Delete a schema. Returns 403 for builtin schemas.
 */
export const deleteSchemaApiIngestionSchemasSchemaIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteSchemaApiIngestionSchemasSchemaIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteSchemaApiIngestionSchemasSchemaIdDeleteResponses, DeleteSchemaApiIngestionSchemasSchemaIdDeleteErrors, ThrowOnError>({ url: '/api/ingestion/schemas/{schema_id}', ...options });

/**
 * Get Schema
 *
 * Get a schema by ID.
 */
export const getSchemaApiIngestionSchemasSchemaIdGet = <ThrowOnError extends boolean = false>(options: Options<GetSchemaApiIngestionSchemasSchemaIdGetData, ThrowOnError>) => (options.client ?? client).get<GetSchemaApiIngestionSchemasSchemaIdGetResponses, GetSchemaApiIngestionSchemasSchemaIdGetErrors, ThrowOnError>({ url: '/api/ingestion/schemas/{schema_id}', ...options });

/**
 * Patch Schema
 *
 * Partially update an existing schema.
 *
 * Returns 404 if not found, 409 if the schema was modified concurrently.
 */
export const patchSchemaApiIngestionSchemasSchemaIdPatch = <ThrowOnError extends boolean = false>(options: Options<PatchSchemaApiIngestionSchemasSchemaIdPatchData, ThrowOnError>) => (options.client ?? client).patch<PatchSchemaApiIngestionSchemasSchemaIdPatchResponses, PatchSchemaApiIngestionSchemasSchemaIdPatchErrors, ThrowOnError>({
    url: '/api/ingestion/schemas/{schema_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Corpus Access
 *
 * What the caller may do here, so the page offers only that.
 */
export const getCorpusAccessApiAdminVectorstoreAccessGet = <ThrowOnError extends boolean = false>(options?: Options<GetCorpusAccessApiAdminVectorstoreAccessGetData, ThrowOnError>) => (options?.client ?? client).get<GetCorpusAccessApiAdminVectorstoreAccessGetResponses, unknown, ThrowOnError>({ url: '/api/admin/vectorstore/access', ...options });

/**
 * Get Corpus Overview
 *
 * The state of the vectorstore: collection sizes and breakdowns.
 */
export const getCorpusOverviewApiAdminVectorstoreOverviewGet = <ThrowOnError extends boolean = false>(options?: Options<GetCorpusOverviewApiAdminVectorstoreOverviewGetData, ThrowOnError>) => (options?.client ?? client).get<GetCorpusOverviewApiAdminVectorstoreOverviewGetResponses, unknown, ThrowOnError>({ url: '/api/admin/vectorstore/overview', ...options });

/**
 * Get Corpus Field Values
 *
 * The values a schema field takes on documents of a type, for the filter dropdowns.
 */
export const getCorpusFieldValuesApiAdminVectorstoreValuesGet = <ThrowOnError extends boolean = false>(options: Options<GetCorpusFieldValuesApiAdminVectorstoreValuesGetData, ThrowOnError>) => (options.client ?? client).get<GetCorpusFieldValuesApiAdminVectorstoreValuesGetResponses, GetCorpusFieldValuesApiAdminVectorstoreValuesGetErrors, ThrowOnError>({ url: '/api/admin/vectorstore/values', ...options });

/**
 * Query Corpus Documents
 *
 * A page of the stored documents matching the filters, one row per source URL.
 */
export const queryCorpusDocumentsApiAdminVectorstoreDocumentsQueryPost = <ThrowOnError extends boolean = false>(options: Options<QueryCorpusDocumentsApiAdminVectorstoreDocumentsQueryPostData, ThrowOnError>) => (options.client ?? client).post<QueryCorpusDocumentsApiAdminVectorstoreDocumentsQueryPostResponses, QueryCorpusDocumentsApiAdminVectorstoreDocumentsQueryPostErrors, ThrowOnError>({
    url: '/api/admin/vectorstore/documents/query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Corpus Document
 *
 * A document's records and a page of its chunks, in reading order.
 */
export const getCorpusDocumentApiAdminVectorstoreDocumentsDetailGet = <ThrowOnError extends boolean = false>(options: Options<GetCorpusDocumentApiAdminVectorstoreDocumentsDetailGetData, ThrowOnError>) => (options.client ?? client).get<GetCorpusDocumentApiAdminVectorstoreDocumentsDetailGetResponses, GetCorpusDocumentApiAdminVectorstoreDocumentsDetailGetErrors, ThrowOnError>({ url: '/api/admin/vectorstore/documents/detail', ...options });

/**
 * Preview Corpus Deletion
 *
 * What deleting the selected documents would remove. Deletes nothing.
 */
export const previewCorpusDeletionApiAdminVectorstoreDeletionsPreviewPost = <ThrowOnError extends boolean = false>(options: Options<PreviewCorpusDeletionApiAdminVectorstoreDeletionsPreviewPostData, ThrowOnError>) => (options.client ?? client).post<PreviewCorpusDeletionApiAdminVectorstoreDeletionsPreviewPostResponses, PreviewCorpusDeletionApiAdminVectorstoreDeletionsPreviewPostErrors, ThrowOnError>({
    url: '/api/admin/vectorstore/deletions/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Corpus Documents
 *
 * Delete everything stored under the URLs a preview returned.
 *
 * Records and chunks are gone when this answers; their images are deleted
 * after the response, so a large delete stays within the request timeout.
 */
export const deleteCorpusDocumentsApiAdminVectorstoreDeletionsPost = <ThrowOnError extends boolean = false>(options: Options<DeleteCorpusDocumentsApiAdminVectorstoreDeletionsPostData, ThrowOnError>) => (options.client ?? client).post<DeleteCorpusDocumentsApiAdminVectorstoreDeletionsPostResponses, DeleteCorpusDocumentsApiAdminVectorstoreDeletionsPostErrors, ThrowOnError>({
    url: '/api/admin/vectorstore/deletions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webapp Version Endpoint
 *
 * Get the webapp version.
 *
 * Returns:
 * str: The webapp version.
 */
export const webappVersionEndpointApiVersionGet = <ThrowOnError extends boolean = false>(options?: Options<WebappVersionEndpointApiVersionGetData, ThrowOnError>) => (options?.client ?? client).get<WebappVersionEndpointApiVersionGetResponses, unknown, ThrowOnError>({ url: '/api/version', ...options });
